import axios from '@/lib/axios';
import { RegistrationParams } from '../types';

const createRegistration = (data: RegistrationParams) => {
  return axios.post('/customer/flat_rates/registration', data);
}

export default createRegistration;